import {combineReducers} from 'redux';

import content from './content';
import attributes from "./attributes";


const rootReducer = combineReducers({
    content,
    attributes
});

export default rootReducer;